import { Chip } from "@base/ui/Chip";
import { Table } from "@base/ui/Table";
import { formatPeriod, getStatusTranslationKey, isActiveStatus } from "@features/admin/lib";
import type { MemberListItem } from "@features/admin/model/types";
import { useTranslation } from "react-i18next";

export interface MembersTableProps {
  members: MemberListItem[];
  onRowClick: (member: MemberListItem) => void;
}

export const MembersTable = ({ members, onRowClick }: MembersTableProps) => {
  const { t } = useTranslation();

  return (
    <Table>
      <Table.Head>
        {/* Company가 가장 길어질 수 있으므로 남는 가로 공간을 전부 가져가고(w-full),
            나머지 컬럼은 내용 너비만 차지하도록 최소 폭(w-px + nowrap)을 준다. */}
        <tr>
          <Table.HeaderCell className="w-full">{t("adminColumnCompany")}</Table.HeaderCell>
          <Table.HeaderCell className="w-px">{t("adminColumnType")}</Table.HeaderCell>
          <Table.HeaderCell className="w-px">{t("adminColumnStatus")}</Table.HeaderCell>
          <Table.HeaderCell className="w-px text-right">{t("adminColumnPeriod")}</Table.HeaderCell>
        </tr>
      </Table.Head>
      <Table.Body>
        {members.map((member) => (
          <Table.Row key={member.company_id} onClick={() => onRowClick(member)}>
            <Table.Cell>{member.company_name}</Table.Cell>
            <Table.Cell>{t(`memberType_${member.type}`)}</Table.Cell>
            <Table.Cell>
              <Chip size="sm" variant="fill" color={isActiveStatus(member.status) ? "info" : "error"}>
                {t(getStatusTranslationKey(member.status))}
              </Chip>
            </Table.Cell>
            <Table.Cell className="text-right">{formatPeriod(member.period, member.status, member.type)}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};
